angular.module('rjmNg.api').factory("References", [
  () ->

    class References
      constructor: (@references) ->

      # Returns a list of references in which either the reference.to.table or the
      # reference.from.table is table
      getReferencesForTable: (table) ->
        @references.filter (reference) ->
          reference.from.table is table or reference.to.table is table

      # Returns a list of references in which one table is fromTable and the
      # other table is toTable. (Returns references in either direction.)
      getReferencesBetweenTables: (fromTable, toTable) ->
        @references.filter (reference) ->
          (reference.from.table is fromTable and reference.to.table is toTable) or
          (reference.to.table is fromTable and reference.from.table is toTable)

      # Given some reference, returns the table id of the other table
      getOtherTableFromReference: (reference, table) ->
        if reference.from.table is table
          reference.to.table
        else
          reference.from.table

      # Returns a list of ids of tables related to the specified table (with no
      # duplicates)
      getRelatedTables: (table) ->
        _.uniq @getReferencesForTable(table).map (reference) ->
            @getOtherTableFromReference(reference, table)
          , @

      # Returns a string representation of a reference.
      #   e.g. "foo.A = bar.B"
      getReferenceStr: (structure, reference) ->
        fromTableName = structure.tables[reference.from.table].name
        fromColumnName = structure.columns[reference.from.column].name

        toTableName = structure.tables[reference.to.table].name
        toColumnName = structure.columns[reference.to.column].name

        "#{fromTableName}.#{fromColumnName} = #{toTableName}.#{toColumnName}"

      # Given two tables, returns an object whose property correspond to the
      # tids of other tables, and whose property values correspond to string
      # representations of the representations between the tables.
      #   e.g. getReferenceStrs(0)[1] == "foo.A = bar.B"
      # TODO: modify this to support multiple references between tables
      getReferenceStrs: (structure, table) ->
        references = @getReferencesForTable(table)
        referenceStrs = {}

        for reference in references
          otherTable = @getOtherTableFromReference(reference, table)
          referenceStrs[otherTable] = @getReferenceStr(structure, reference)

        referenceStrs

  ]
)
